import { getCountryCodeFromDomain } from "@sleek/customer-common-acquisition";
import pMemoize from "p-memoize";

const memoizedCountryCodeFromDomain = pMemoize(getCountryCodeFromDomain);

export { memoizedCountryCodeFromDomain };
